import React, {useState} from 'react';
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { imagesClockRoom } from '../assets/clockRoomImages';

const ClockRoomGallery = () => {
  
    const [index, setIndex] = useState(-1);

    const currentImage = imagesClockRoom[index];
    const nextIndex = (index + 1) % imagesClockRoom.length;
    const nextImage = imagesClockRoom[nextIndex] || currentImage;
    const prevIndex = (index + imagesClockRoom.length - 1) % imagesClockRoom.length;
    const prevImage = imagesClockRoom[prevIndex] || currentImage;
  
    const handleClick = (index) => {
      setIndex(index);
    }
    const handleClose = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);  
 return (
        <div>   
        <Gallery 
          images={imagesClockRoom} 
          onClick={handleClick} 
          enableImageSelection={false}
        />
        {!!currentImage && (
          <Lightbox
            mainSrc={currentImage.original}
            imageTitle={currentImage.caption}
            mainSrcThumbnail={currentImage.src}
            nextSrc={nextImage.original}
            nextSrcThumbnail={nextImage.src}
            prevSrc={prevImage.original}
            prevSrcThumbnail={prevImage.src}
            onCloseRequest={handleClose}
            onMovePrevRequest={handleMovePrev}
            onMoveNextRequest={handleMoveNext}
          />
        )}
        </div> 
    );

};

export default ClockRoomGallery;